module.exports = __webpack_public_path__ + "img/toggler.41d9fdd1.svg";